import appStore from "@/stores/appStore";
import "./TimbreSelector.less";

interface ITimberSelector {
  activeId: number;
  handleActiveIndex: (id: number) => void;
}

const timbreConfigList = [
  { name: "中文", id: 1 },
  ...(!appStore.isOdm
    ? [
        { name: "英语", id: 3 },
        { name: "日语", id: 4 },
        { name: "韩语", id: 5 },
        { name: "泰语", id: 7 },
      ]
    : []),
  { name: "自定义", id: 6 },
];

const TimberSelector: React.FC<ITimberSelector> = (props) => {
  const { activeId, handleActiveIndex } = props;
  return (
    <div className="timberSelector">
      {timbreConfigList.map((item, index) => {
        return (
          <div
            onClick={() => {
              handleActiveIndex(item.id);
            }}
            key={item.name + index}
            className={`${activeId === item.id ? "active" : ""} timber-selector-block`}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
};

export default TimberSelector;
